import { render, staticRenderFns } from "./4_donationConfirm.vue?vue&type=template&id=08df1620"
import script from "./4_donationConfirm.vue?vue&type=script&lang=js"
export * from "./4_donationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08df1620')) {
      api.createRecord('08df1620', component.options)
    } else {
      api.reload('08df1620', component.options)
    }
    module.hot.accept("./4_donationConfirm.vue?vue&type=template&id=08df1620", function () {
      api.rerender('08df1620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/donation/4_donationConfirm.vue"
export default component.exports